<template>
  <div id="providerInfoRef" class="col-12 bg-white rounded p-2">
    <validation-observer ref="providerInfoRef" v-slot="{}" tag="form">
      <div class="row py-2 mr-md-0 align-items-center">
        <div class="col-md-12">
          <div class="row mb-3">
            <div class="col-12 col-md-4">
              <validation-provider
                v-slot="{ errors, failedRules }"
                name="ssn"
                :rules="{ required: true, ssnpatronal: true }"
              >
                <label class="data-title mb-n3">SSN Patronal:</label>
                <custom-input
                  v-model="model.ssn"
                  custom-error-msg=""
                  :error="errors[0]"
                  mask-type="SSNPatronal"
                  placeholder="Escriba SSN Patronal"
                  type="text"
                />
                <error
                  v-if="failedRules.required"
                  message="El SSN es requerido."
                  variant="no-border"
                />
                <error
                  v-if="failedRules.ssnpatronal"
                  message="El SSN entrado no es válido."
                  variant="no-border"
                />
              </validation-provider>
            </div>
            <div class="col-12 col-md-4">
              <validation-provider v-slot="{ errors }" rules="required">
                <label class="data-title mb-0">Tipo de Proveedor:</label>
                <custom-drop-down
                  v-model="model.providerType"
                  :clearable="false"
                  custom-error-msg="El tipo de proveedor es requerido."
                  :disabled="!canEditProvider"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="providerTypes"
                  placeholder="Seleccione"
                  @input="onChangeProviderTypeHandler"
                />
              </validation-provider>
            </div>
            <div class="col-12 col-md-4 mt-3">
              <check-box
                v-if="isCompanyProviderType"
                v-model="model.isIncorporatedCompany"
                class="my-2 check-box__extended"
                text="¿Compañía es incorporada?"
              />
              <check-box
                v-if="isIndividualProviderType"
                v-model="model.isServiceAssistant"
                class="my-2 check-box__extended"
                text="¿Es Asistente de Servicio?"
              />
            </div>
          </div>
          <div v-if="isCompanyProviderType" class="row">
            <div class="col-12 col-md-10">
              <validation-provider v-slot="{ errors }" rules="required">
                <label class="data-title mb-0">Nombre del Proveedor:</label>
                <custom-input
                  v-model="model.providerName"
                  custom-error-msg="El nombre del proveedor es requerido."
                  :error="errors[0]"
                  type="text"
                />
              </validation-provider>
            </div>
            <div
              class="col col-sm col-2 d-flex align-items-center justify-content-end mt-3 mr-n4"
            >
              <action-button
                class="btn-action-size"
                i="fas fa-save pl-1"
                variant="outline-success pl-1"
                @click="submitForm()"
              />
              <action-button
                class="btn-action-size"
                i="fas fa-ban pl-1"
                variant="outline-danger m-2 pl-1"
                @click="onCloseEditHandler()"
              />
            </div>
          </div>
          <div v-if="isIndividualProviderType" class="row">
            <div class="col-12 col-md-4">
              <validation-provider v-slot="{ errors }" rules="required">
                <label class="data-title mb-0">Nombre:</label>
                <custom-input
                  v-model="model.nameFirst"
                  class="w-74"
                  custom-error-msg="El nombre es requerido."
                  :error="errors[0]"
                  type="text"
                />
              </validation-provider>
            </div>
            <div class="col-12 col-md-4">
              <validation-provider v-slot="{ errors }" rules="required">
                <label class="data-title mb-0">Apellido Paterno:</label>
                <custom-input
                  v-model="model.nameLastPaternal"
                  class="w-74"
                  custom-error-msg="El apellido paterno es requerido."
                  :error="errors[0]"
                  type="text"
                />
              </validation-provider>
            </div>
            <div class="col-12 col-md-3 mr-2">
              <label class="data-title mb-0">Apellido Materno:</label>
              <custom-input v-model="model.nameLastMaternal" type="text" />
            </div>
            <div
              class="col col-sm col-md-1 mr-n4 mt-3 p-0 d-flex align-items-center justify-content-end"
            >
              <action-button
                class="btn-action-size"
                i="fas fa-save pl-1"
                variant="outline-success pl-1"
                @click="submitForm()"
              />
              <action-button
                class="btn-action-size"
                i="fas fa-ban pl-1"
                variant="outline-danger m-2 pl-1"
                @click="onCloseEditHandler()"
              />
            </div>
          </div>
          <div v-if="model.primaryCompanyName" class="row">
            <div class="col-12 col-md-12">
              <label class="data-title mb-0">
                Proveedor adicional del mismo Seguro Social con la Compañía
                Primaria:
              </label>
              <span class="color-black font-16 font-weight-bold ml-2">
                {{ model.primaryCompanyName }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CheckBox from 'CheckBox';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import Error from 'custom-error';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import providerTypes from '@/utils/constants/providerTypes.js';
import { editProviderInfo } from '@/services/provider/provider.api';

export default {
  name: 'EditProviderInfo',
  mixins: [alertMixin],
  data: () => ({
    model: {
      id: null,
      ssn: null,
      parentMainCompanyId: null,
      providerType: null,
      isMainCompany: false,
      isRpProvider: false,
      isIncorporatedCompany: false,
      isServiceAssistant: false,
      providerName: null,
      nameFirst: null,
      nameLastPaternal: null,
      nameLastMaternal: null,
    },
  }),
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    providerTypes: {
      type: Array,
      default: () => [],
    },
    canEditProvider: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ValidationProvider,
    CustomDropDown,
    CheckBox,
    CustomInput,
    ActionButton,
    Error,
  },
  computed: {
    isIndividualProviderType() {
      return this.model.providerType?.id === providerTypes.Individual;
    },
    isCompanyProviderType() {
      return (
        this.model.providerType?.id === providerTypes.Company ||
        this.model.providerType?.id === providerTypes.DBA
      );
    },
  },
  mounted() {
    this.model = {
      ...this.value,
    };
  },
  methods: {
    onCloseEditHandler() {
      this.$emit('cancel');
    },
    onChangeProviderTypeHandler() {
      if (this.model.providerType?.id === providerTypes.Company) {
        this.model = {
          ...this.model,
          providerName: this.value.providerName,
          nameFirst: null,
          nameLastPaternal: null,
          nameLastMaternal: null,
          isIncorporatedCompany: this.value.isIncorporatedCompany,
          isServiceAssistant: false,
        };
      } else {
        this.model = {
          ...this.model,
          providerName: null,
          nameFirst: this.value.nameFirst,
          nameLastPaternal: this.value.nameLastPaternal,
          nameLastMaternal: this.value.nameLastMaternal,
          isIncorporatedCompany: false,
          isServiceAssistant: this.value.isServiceAssistant,
        };
      }
    },
    async submitForm() {
      const isValid = await this.$refs.providerInfoRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      const payload = {
        company: {
          id: this.model.id,
          ssn: this.model.ssn,
          parentMainCompanyId: this.model.parentMainCompanyId,
          companyTypeCd: this.model.providerType.id,
          isMainCompany: this.model.isMainCompany,
          isRpProvider: this.model.isRpProvider,
          isIncorporatedCompany: this.model.isIncorporatedCompany,
          isServiceAssistant: this.model.isServiceAssistant,
          name: this.model.providerName,
          nameFirst: this.model.nameFirst,
          nameLastPaternal: this.model.nameLastPaternal,
          nameLastMaternal: this.model.nameLastMaternal,
        },
      };

      const { data } = await editProviderInfo(payload).catch((error) => {
        this.ShowToast('Alerta', `${error.response.data.message}`, 'error');
        return { data: false };
      });

      if (data)
        this.ShowToast(
          `Confirmación`,
          'La información del proveedor ha sido actualizada exitosamente.',
          'success'
        );

      this.$emit('save');
    },
  },
};
</script>

<style scoped lang="scss">
.btn-action-size {
  width: 35px;
  height: 35px;
}

.w-74 {
  width: 74%;
}
</style>
